const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function signupUser(data: {
  username: string;
  mobile: string;
  password_hash: string;
}) {
  const response = await fetch(`${BASE_URL}/api/users/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || "Signup failed");
  }

  return response.json();
}
